import type { GlobalDataSourceId } from '#layers/data-model/types/schema/ids';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';

// A new junction inherits the source collection's data source before it exists in the schema.
export function junctionComparisonSourceId(
	junction: Pick<ResolvedMonospaceCollection, 'sourceId'> | null | undefined,
	sourceCollection: Pick<ResolvedMonospaceCollection, 'sourceId'>,
): GlobalDataSourceId {
	return junction?.sourceId ?? sourceCollection.sourceId;
}

// Wait until both collections are selected before treating a relation as cross-source.
export function isCrossSourceRelation(
	sourceId: GlobalDataSourceId | null | undefined,
	otherSourceId: GlobalDataSourceId | null | undefined,
): boolean {
	return !!sourceId && !!otherSourceId && sourceId !== otherSourceId;
}
